export const templateHome = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Nemonto — Home</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30;
    --spice-deep:#B23D18;
    --cream:#FAECE7;
    --peach:#F5C4B3;
    --charcoal:#2C2C2A;
    --herb:#1D9E75;
    --gold:#FAC775;
    --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif;
    --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{
    background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px;
    height:100vh; overflow:hidden;
  }
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{
    display:grid;
    grid-template-columns:264px minmax(0,1fr) 300px;
    height:100vh;
    width:100%;
    max-width:none;
    margin:0;
  }

  /* ============ LEFT SIDEBAR ============ */
  .sidebar{
    padding:26px 18px; display:flex; flex-direction:column; height:100vh;
    border-right:1px solid rgba(44,44,42,0.07);
  }
  .brand{display:flex; align-items:center; gap:9px; font-family:var(--serif); font-size:21px; padding:0 10px 28px;}

  .nav-section{margin-bottom:6px;}
  .nav-item{
    display:flex; align-items:center; gap:13px; padding:11px 12px; border-radius:14px; width:100%;
    font-size:15px; font-weight:500; color:#6B5F58; position:relative; transition:background .15s, color .15s;
  }
  .nav-item:hover{background:rgba(44,44,42,0.04);}
  .nav-item.active{background:var(--spice); color:var(--cream);}
  .nav-item.active .steam{opacity:1;}
  .nav-icon{width:21px; height:21px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .nav-badge{
    margin-left:auto; background:var(--gold); color:#5A3A00; font-size:10.5px; font-weight:700;
    padding:2px 7px; border-radius:20px;
  }
  .nav-item.active .nav-badge{background:rgba(250,236,231,0.25); color:var(--cream);}
  .steam{
    position:absolute; top:-3px; left:28px; width:3px; height:10px; opacity:0; transition:opacity .2s;
  }

  .sidebar-divider{height:1px; background:rgba(44,44,42,0.07); margin:16px 10px;}

  .post-btn{
    margin:10px 10px 22px; background:var(--spice); color:var(--cream); padding:13px; border-radius:16px;
    font-size:14.5px; font-weight:700; display:flex; align-items:center; justify-content:center; gap:8px;
    transition:transform .15s, box-shadow .15s;
  }
  .post-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}

  .sidebar-spacer{flex:1;}

  .seats-card{
    background:var(--charcoal); border-radius:18px; padding:18px; margin:0 10px 14px; position:relative; overflow:hidden;
  }
  .seats-card::before{content:''; position:absolute; top:-60px; right:-50px; width:140px; height:140px; background:radial-gradient(circle, rgba(216,90,48,0.4), transparent 70%);}
  .seats-card p.label{font-size:10.5px; letter-spacing:0.06em; text-transform:uppercase; color:var(--gold); margin-bottom:8px; position:relative;}
  .seats-card p.title{font-family:var(--serif); font-size:15px; color:var(--cream); line-height:1.3; margin-bottom:10px; position:relative;}
  .seats-card a{display:inline-block; font-size:12px; font-weight:700; color:var(--gold); position:relative;}

  .profile-mini{display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:14px; transition:background .15s;}
  .profile-mini:hover{background:rgba(44,44,42,0.04);}
  .pm-avatar{width:38px; height:38px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pm-name{font-size:13.5px; font-weight:600; color:var(--charcoal);}
  .pm-handle{font-size:11.5px; color:#9A8C84;}
  .pm-more{margin-left:auto; color:#9A8C84;}

  /* ============ CENTER FEED ============ */
  .feed-col{height:100vh; overflow-y:auto; border-right:1px solid rgba(44,44,42,0.07);}
  .feed-header{
    position:sticky; top:0; z-index:5; background:rgba(241,228,222,0.92); backdrop-filter:blur(8px);
    padding:20px 32px 14px; border-bottom:1px solid rgba(44,44,42,0.06);
  }
  .feed-header h1{font-family:var(--serif); font-size:23px;}
  .feed-tabs{display:flex; gap:22px; margin-top:14px;}
  .feed-tab{font-size:13.5px; font-weight:600; color:#9A8C84; padding-bottom:10px; position:relative;}
  .feed-tab.active{color:var(--spice-deep);}
  .feed-tab.active::after{content:''; position:absolute; bottom:0; left:0; right:0; height:2.5px; background:var(--spice); border-radius:2px;}

  .feed-body{padding:24px 32px 60px; max-width:none;}

  /* composer */
  .composer{
    background:#fff; border-radius:20px; padding:16px 18px; display:flex; gap:12px; align-items:flex-start;
    margin-bottom:22px; border:1px solid rgba(44,44,42,0.06);
  }
  .composer-avatar{width:40px; height:40px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .composer-input{
    flex:1; background:#F8EFEB; border-radius:24px; padding:11px 16px; font-size:13.5px; color:#9A8C84;
  }
  .composer-icon{
    width:38px; height:38px; border-radius:50%; background:#F8EFEB; display:flex; align-items:center; justify-content:center;
    flex-shrink:0; color:var(--spice-deep);
  }

  /* story rail */
  .story-rail{display:flex; gap:14px; margin-bottom:26px; overflow-x:auto; padding-bottom:4px;}
  .story{display:flex; flex-direction:column; align-items:center; gap:6px; flex-shrink:0; width:62px;}
  .story-ring{width:56px; height:56px; border-radius:50%; border:2.5px solid var(--spice); padding:2.5px;}
  .story-ring.seen{border-color:rgba(44,44,42,0.15);}
  .story-avatar{width:100%; height:100%; border-radius:50%;}
  .story-add{
    width:56px; height:56px; border-radius:50%; background:#fff; border:2px dashed rgba(216,90,48,0.4);
    display:flex; align-items:center; justify-content:center; color:var(--spice); font-size:20px;
  }
  .story-name{font-size:10.5px; color:#6B5F58; text-align:center;}

  /* post cards */
  .post-card{background:#fff; border-radius:22px; margin-bottom:20px; overflow:hidden; border:1px solid rgba(44,44,42,0.06);}
  .post-top{display:flex; align-items:center; gap:10px; padding:14px 18px 12px;}
  .post-avatar{width:38px; height:38px; border-radius:50%; flex-shrink:0;}
  .post-who b{font-size:13.5px; font-weight:600; color:var(--charcoal); display:block;}
  .post-who span{font-size:11.5px; color:#9A8C84;}
  .post-more{margin-left:auto; color:#B6A89F;}
  .post-thumb{height:280px; position:relative; display:flex; align-items:center; justify-content:center;}
  .challenge-flag{
    position:absolute; top:14px; left:14px; background:var(--charcoal); color:var(--gold); font-size:11px; font-weight:700;
    padding:5px 11px; border-radius:20px; display:flex; align-items:center; gap:5px;
  }
  .post-body{padding:14px 18px 16px;}
  .post-title{font-family:var(--serif); font-size:18px; margin-bottom:5px;}
  .post-desc{font-size:13px; color:#6B5F58; line-height:1.55; margin-bottom:12px;}
  .post-actions{display:flex; align-items:center; gap:18px;}
  .pa-btn{display:flex; align-items:center; gap:6px; font-size:13px; color:#6B5F58; font-weight:500;}
  .pa-btn.liked{color:var(--spice-deep);}
  .made-pill-btn{
    margin-left:auto; background:var(--spice); color:var(--cream); font-size:12px; font-weight:700;
    padding:8px 16px; border-radius:30px;
  }

  /* ============ RIGHT RAIL ============ */
  .right-rail{height:100vh; overflow-y:auto; padding:24px 20px 40px;}
  .rail-block{margin-bottom:30px;}
  .rail-head{display:flex; align-items:center; justify-content:space-between; margin-bottom:14px;}
  .rail-head h3{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#6B5F58;}
  .rail-head a{font-size:12px; color:var(--spice-deep); font-weight:600;}

  .rail-tabs{display:flex; background:rgba(44,44,42,0.05); border-radius:12px; padding:4px; margin-bottom:14px;}
  .rail-tab{flex:1; text-align:center; font-size:12px; font-weight:600; padding:7px 0; border-radius:9px; color:#9A8C84;}
  .rail-tab.active{background:#fff; color:var(--spice-deep); box-shadow:0 2px 6px rgba(44,28,18,0.08);}

  .person-row{display:flex; align-items:center; gap:10px; padding:9px 4px; border-radius:12px; transition:background .15s;}
  .person-row:hover{background:rgba(255,255,255,0.6);}
  .pr-avatar{width:38px; height:38px; border-radius:50%; flex-shrink:0;}
  .pr-name{font-size:13px; font-weight:600; color:var(--charcoal); display:flex; align-items:center; gap:5px;}
  .pr-meta{font-size:11px; color:#9A8C84;}
  .pr-action{margin-left:auto; font-size:11.5px; font-weight:700; padding:6px 13px; border-radius:20px; white-space:nowrap;}
  .pr-action.follow{background:var(--spice); color:#fff;}
  .pr-action.following{background:transparent; border:1px solid rgba(44,44,42,0.15); color:#6B5F58;}

  .badge-creator{
    width:14px; height:14px; border-radius:50%; background:var(--gold); display:flex; align-items:center; justify-content:center;
    font-size:8px; flex-shrink:0;
  }

  .suggestion-card{
    background:#fff; border-radius:16px; padding:14px; border:1px solid rgba(44,44,42,0.06); margin-bottom:10px;
  }
  .sc-top{display:flex; align-items:center; gap:10px; margin-bottom:8px;}
  .sc-avatar{width:34px; height:34px; border-radius:50%;}
  .sc-name{font-size:12.5px; font-weight:600;}
  .sc-tag{font-size:11px; color:#9A8C84;}
  .sc-reason{font-size:11.5px; color:#9A8C84; margin-bottom:10px; line-height:1.4;}
  .sc-follow{width:100%; background:var(--cream); color:var(--spice-deep); font-size:12px; font-weight:700; padding:7px 0; border-radius:10px; border:1px solid rgba(216,90,48,0.18);}

  .challenge-mini{
    background:var(--charcoal); border-radius:18px; padding:18px; position:relative; overflow:hidden;
  }
  .challenge-mini::before{content:''; position:absolute; top:-50px; right:-40px; width:120px; height:120px; background:radial-gradient(circle, rgba(216,90,48,0.4), transparent 70%);}
  .cm-live{display:inline-flex; align-items:center; gap:5px; background:var(--spice); color:#fff; font-size:10px; font-weight:700; padding:4px 9px; border-radius:20px; margin-bottom:10px; position:relative;}
  .cm-live .dot{width:5px; height:5px; border-radius:50%; background:#fff; animation:pulse 1.8s infinite;}
  @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.3;}}
  .cm-title{font-family:var(--serif); font-size:15px; color:var(--cream); margin-bottom:8px; line-height:1.3; position:relative;}
  .cm-meta{font-size:11px; color:rgba(250,236,231,0.6); margin-bottom:12px; position:relative;}
  .cm-btn{display:block; text-align:center; background:var(--gold); color:#5A3A00; font-size:12px; font-weight:700; padding:9px 0; border-radius:12px; position:relative;}

  @media (max-width:1180px){
    .app{grid-template-columns:84px minmax(0,1fr) 300px;}
    .brand span.brand-text, .nav-item span.nav-label, .post-btn span.btn-label, .seats-card, .profile-mini .pm-text{display:none;}
    .nav-item{justify-content:center;}
    .nav-badge{display:none;}
    .post-btn{padding:13px;}
    .profile-mini{justify-content:center;}
  }
  @media (max-width:900px){
    .app{grid-template-columns:84px minmax(0,1fr);}
    .right-rail{display:none;}
  }
</style>
</head>
<body>

<div class="app">

  <!-- ================= LEFT SIDEBAR ================= -->
  <aside class="sidebar">
    <div class="brand">
      <img src="../image/nemonto-logo.png" alt="Nemonto" style="height:32px; width:auto; display:block;" />
    </div>

    <nav class="nav-section">
      <a class="nav-item active" href="#">
        <svg class="steam" viewBox="0 0 3 10" aria-hidden="true"><path d="M1.5 9C0.5 7 2 5.5 1 4C0.3 3 1 1.5 1.5 1" stroke="#FAC775" stroke-width="1" fill="none" stroke-linecap="round"/></svg>
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 11l8-7 8 7M6 10v9a1 1 0 001 1h4v-6h2v6h4a1 1 0 001-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Home</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Explore</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Made it</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h14a1 1 0 011 1v16l-8-4-8 4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Challenges</span>
        <span class="nav-badge">3 live</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Saved</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.4 8.4 0 01-1.2 4.4L21 20l-4.3-1.2a8.5 8.5 0 11-1.8-15.6 8.5 8.5 0 016.1 7.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Messages</span>
        <span class="nav-badge">2</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/><path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Profile</span>
      </a>
    </nav>

    <div class="post-btn">
      <svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      <span class="btn-label">New recipe</span>
    </div>

    <div class="sidebar-spacer"></div>

    <div class="seats-card">
      <p class="label">Founding creators</p>
      <p class="title">47 of 100 seats claimed. Apply before they're gone.</p>
      <a href="#">Apply now →</a>
    </div>

    <div class="profile-mini">
      <div class="pm-avatar"></div>
      <div class="pm-text">
        <div class="pm-name">Priya Rajan</div>
        <div class="pm-handle">@priyacooks</div>
      </div>
      <span class="pm-more">⋯</span>
    </div>
  </aside>

  <!-- ================= CENTER FEED ================= -->
  <main class="feed-col">
    <div class="feed-header">
      <h1>Home</h1>
      <div class="feed-tabs">
        <span class="feed-tab active">For you</span>
        <span class="feed-tab">Following</span>
        <span class="feed-tab">South Asian</span>
        <span class="feed-tab">Italian</span>
      </div>
    </div>

    <div class="feed-body">

      <div class="composer">
        <div class="composer-avatar"></div>
        <div class="composer-input">What did you cook today, Priya?</div>
        <div class="composer-icon">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M4 7h3l1.5-2.5h7L17 7h3a1 1 0 011 1v11a1 1 0 01-1 1H4a1 1 0 01-1-1V8a1 1 0 011-1z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.4" stroke="currentColor" stroke-width="1.6"/></svg>
        </div>
      </div>

      <div class="story-rail">
        <div class="story">
          <div class="story-add">+</div>
          <span class="story-name">Your story</span>
        </div>
        <div class="story">
          <div class="story-ring"><div class="story-avatar" style="background:#F0997B;"></div></div>
          <span class="story-name">Maria</span>
        </div>
        <div class="story">
          <div class="story-ring"><div class="story-avatar" style="background:#FAC775;"></div></div>
          <span class="story-name">Sofia</span>
        </div>
        <div class="story">
          <div class="story-ring seen"><div class="story-avatar" style="background:#AFA9EC;"></div></div>
          <span class="story-name">James</span>
        </div>
        <div class="story">
          <div class="story-ring seen"><div class="story-avatar" style="background:#F5C4B3;"></div></div>
          <span class="story-name">Chen</span>
        </div>
      </div>

      <!-- post 1 -->
      <article class="post-card">
        <div class="post-top">
          <div class="post-avatar" style="background:#F0997B;"></div>
          <div class="post-who"><b>Maria K.</b><span>Italian · 12 min ago</span></div>
          <span class="post-more">⋯</span>
        </div>
        <div class="post-thumb" style="background:linear-gradient(150deg,#E8916F,#B23D18);">
          <svg width="58" height="58" viewBox="0 0 100 100" aria-hidden="true"><ellipse cx="50" cy="76" rx="32" ry="6" fill="#7A2A0A" opacity="0.4"/><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.9"/><path d="M16 47 Q16 53 21 53 L79 53 Q84 53 84 47 Q84 38 50 38 Q16 38 16 47 Z" fill="#fff"/></svg>
          <span class="challenge-flag">⚑ Challenge entry</span>
        </div>
        <div class="post-body">
          <p class="post-title">Cacio e Pepe — nonna's version</p>
          <p class="post-desc">Only 3 ingredients. The pasta water is the whole secret — no cream, ever.</p>
          <div class="post-actions">
            <span class="pa-btn liked">♥ 142</span>
            <span class="pa-btn">💬 38</span>
            <span class="pa-btn">↗ Share</span>
            <button class="made-pill-btn">Made it?</button>
          </div>
        </div>
      </article>

      <!-- post 2 -->
      <article class="post-card">
        <div class="post-top">
          <div class="post-avatar" style="background:#9FE1CB;"></div>
          <div class="post-who"><b>Priya R.</b><span>South Asian · 1 hr ago</span></div>
          <span class="post-more">⋯</span>
        </div>
        <div class="post-thumb" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
          <svg width="58" height="58" viewBox="0 0 100 100" aria-hidden="true"><ellipse cx="50" cy="55" rx="28" ry="8" fill="#085041" opacity="0.4"/><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/><circle cx="58" cy="40" r="8" fill="#fff" opacity="0.7"/><circle cx="64" cy="54" r="6" fill="#fff" opacity="0.6"/></svg>
        </div>
        <div class="post-body">
          <p class="post-title">Dal Tadka with ghee drizzle</p>
          <p class="post-desc">Comfort in a bowl. 89 people have made this so far — tag me if you try it.</p>
          <div class="post-actions">
            <span class="pa-btn">♥ 89</span>
            <span class="pa-btn">💬 21</span>
            <span class="pa-btn">↗ Share</span>
            <button class="made-pill-btn">Made it?</button>
          </div>
        </div>
      </article>

      <!-- post 3 -->
      <article class="post-card">
        <div class="post-top">
          <div class="post-avatar" style="background:#AFA9EC;"></div>
          <div class="post-who"><b>James L.</b><span>BBQ · 3 hr ago</span></div>
          <span class="post-more">⋯</span>
        </div>
        <div class="post-thumb" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
          <svg width="58" height="58" viewBox="0 0 100 100" aria-hidden="true"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.5"/><rect x="28" y="24" width="44" height="13" rx="6" fill="#fff" opacity="0.75"/></svg>
          <span class="challenge-flag" style="background:var(--gold); color:#5A3A00;">🏆 Challenge winner</span>
        </div>
        <div class="post-body">
          <p class="post-title">Low-and-slow smoked brisket</p>
          <p class="post-desc">8 hours, no peeking. Won this week's BBQ challenge against 52 other entries.</p>
          <div class="post-actions">
            <span class="pa-btn liked">♥ 341</span>
            <span class="pa-btn">💬 64</span>
            <span class="pa-btn">↗ Share</span>
            <button class="made-pill-btn">Made it?</button>
          </div>
        </div>
      </article>

    </div>
  </main>

  <!-- ================= RIGHT RAIL ================= -->
  <aside class="right-rail">

    <div class="rail-block">
      <div class="challenge-mini">
        <span class="cm-live"><span class="dot"></span>LIVE NOW</span>
        <p class="cm-title">Pasta with 3 ingredients only</p>
        <p class="cm-meta">84 entries · 47h left · by Maria K.</p>
        <a href="#" class="cm-btn">Enter challenge</a>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head">
        <h3>Your circle</h3>
      </div>
      <div class="rail-tabs">
        <div class="rail-tab active" data-tab="followers">Followers · 1.8k</div>
        <div class="rail-tab" data-tab="following">Following · 312</div>
      </div>

      <div id="followers-list">
        <div class="person-row">
          <div class="pr-avatar" style="background:#F0997B;"></div>
          <div>
            <div class="pr-name">Maria K. <span class="badge-creator">🏅</span></div>
            <div class="pr-meta">Italian · 8.2K followers</div>
          </div>
          <button class="pr-action following">Following</button>
        </div>
        <div class="person-row">
          <div class="pr-avatar" style="background:#FAC775;"></div>
          <div>
            <div class="pr-name">Sofia M.</div>
            <div class="pr-meta">Bakery · 6.7K followers</div>
          </div>
          <button class="pr-action follow">Follow</button>
        </div>
        <div class="person-row">
          <div class="pr-avatar" style="background:#F5C4B3;"></div>
          <div>
            <div class="pr-name">Dana P.</div>
            <div class="pr-meta">Healthy · 940 followers</div>
          </div>
          <button class="pr-action follow">Follow</button>
        </div>
        <div class="person-row">
          <div class="pr-avatar" style="background:#9890DF;"></div>
          <div>
            <div class="pr-name">Tom R.</div>
            <div class="pr-meta">BBQ · 2.1K followers</div>
          </div>
          <button class="pr-action following">Following</button>
        </div>
        <div class="person-row">
          <div class="pr-avatar" style="background:#6FCBA4;"></div>
          <div>
            <div class="pr-name">Lena W.</div>
            <div class="pr-meta">East Asian · 1.4K followers</div>
          </div>
          <button class="pr-action follow">Follow</button>
        </div>
      </div>

      <div id="following-list" style="display:none;">
        <div class="person-row">
          <div class="pr-avatar" style="background:#9FE1CB;"></div>
          <div>
            <div class="pr-name">Priya R. <span class="badge-creator">🏅</span></div>
            <div class="pr-meta">South Asian · 12.4K followers</div>
          </div>
          <button class="pr-action following">Following</button>
        </div>
        <div class="person-row">
          <div class="pr-avatar" style="background:#AFA9EC;"></div>
          <div>
            <div class="pr-name">James L. <span class="badge-creator">🏅</span></div>
            <div class="pr-meta">BBQ · 3.1K followers</div>
          </div>
          <button class="pr-action following">Following</button>
        </div>
        <div class="person-row">
          <div class="pr-avatar" style="background:#F0997B;"></div>
          <div>
            <div class="pr-name">Maria K. <span class="badge-creator">🏅</span></div>
            <div class="pr-meta">Italian · 8.2K followers</div>
          </div>
          <button class="pr-action following">Following</button>
        </div>
        <div class="person-row">
          <div class="pr-avatar" style="background:#F5C4B3;"></div>
          <div>
            <div class="pr-name">Chen W.</div>
            <div class="pr-meta">East Asian · 22K followers</div>
          </div>
          <button class="pr-action following">Following</button>
        </div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head">
        <h3>Suggested for you</h3>
        <a href="#">See all</a>
      </div>

      <div class="suggestion-card">
        <div class="sc-top">
          <div class="sc-avatar" style="background:#BA7517;"></div>
          <div>
            <div class="sc-name">Aisha K.</div>
            <div class="sc-tag">Middle Eastern</div>
          </div>
        </div>
        <p class="sc-reason">Followed by Priya R. and 3 others you know</p>
        <button class="sc-follow">Follow</button>
      </div>

      <div class="suggestion-card">
        <div class="sc-top">
          <div class="sc-avatar" style="background:#1D9E75;"></div>
          <div>
            <div class="sc-name">Marco T.</div>
            <div class="sc-tag">Mediterranean</div>
          </div>
        </div>
        <p class="sc-reason">Posts a lot in South Asian + Italian, like you</p>
        <button class="sc-follow">Follow</button>
      </div>
    </div>

  </aside>

</div>

<script>
  document.querySelectorAll('.rail-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.rail-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const isFollowers = tab.dataset.tab === 'followers';
      document.getElementById('followers-list').style.display = isFollowers ? 'block' : 'none';
      document.getElementById('following-list').style.display = isFollowers ? 'none' : 'block';
    });
  });

  document.querySelectorAll('.pr-action').forEach(btn => {
    btn.addEventListener('click', () => {
      const isFollowing = btn.classList.contains('following');
      btn.classList.toggle('following', !isFollowing);
      btn.classList.toggle('follow', isFollowing);
      btn.textContent = isFollowing ? 'Follow' : 'Following';
    });
  });

  document.querySelectorAll('.feed-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.feed-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
    });
  });

  document.querySelectorAll('.pa-btn').forEach(btn => {
    if(btn.textContent.includes('♥')){
      btn.addEventListener('click', () => {
        btn.classList.toggle('liked');
      });
    }
  });
</script>

</body>
</html>

`;
